<template>
  <div>
    <div class="readOnly">本demo仅作为功能演示，不提供实际的在线文档服务。</div>
    <div class="container">
      <!--      <div class="form-box1">-->
      <!--        <el-button @click="oneKeyComment">一键添加批注</el-button>-->
      <!--      </div>-->
      <!--        <button type="button" id="id-left-button" @click="actionShowLeftBar" ref="show">{{showLeftBar ? '收起' : '展开'}}</button>-->
      <div class="left-bar" v-show="showLeftBar">
        <left-bar v-bind:fileType="fileType"
                  v-bind:docEditor="docEditor"
                  v-bind:config="config"
                  v-bind:ctctrlTree="ctctrlTree"
                  v-bind:ctctrlContentAll="ctctrlContentAll"
                  v-bind:extractedText="extractedText"
                  v-bind:extractedRevision="extractedRevision"
                  v-bind:outjson="outjson"
                  v-bind:extractedComment="extractedComment"
                  v-bind:extractedCellContent="extractedCellContent"
                  v-bind:extractedCellContentAll="extractedCellContentAll"
        ></left-bar>
      </div>

      <div class="quick-bar" v-show="showQuickBar">
        <div class="form-box" v-show="showContract">
          <div class="form-box-title">{{ '合同信息' }}</div>
          <div class="form-box-content">
            <el-form ref="form" :model="form" label-width="80px" label-position="left" size="small">
              <el-row>
                <el-col><el-form-item label="甲方名称:">
                  <el-input v-model="form.aName" maxlength="20" placeholder="请输入甲方名称"></el-input>
                </el-form-item></el-col>
              </el-row>
              <el-row>
                <el-col><el-form-item label="乙方名称:">
                  <el-input v-model="form.bName" maxlength="20" placeholder="请输入乙方名称"></el-input>
                </el-form-item></el-col>
              </el-row>
              <el-row>
                <el-col><el-form-item label="项目编号:"><!-- 校验只能输入大小写字母和下划线-->
                  <el-input v-model="form.projectNumber"
                            @input="form.projectNumber=form.projectNumber.replace(/[^\w_]/g,'');"

                            maxlength="20" placeholder="请输入项目编号"></el-input>
                </el-form-item></el-col>
              </el-row>
              <el-row>
                <el-col>
                  <el-form-item label="货品:">
                    <el-select v-model="form.shop" @change="changeAdd" placeholder="请选择货品">
                      <el-option label="计算机，标准版，10000" value="1"></el-option>
                      <el-option label="办公桌，高级版，1000" value="2"></el-option>
                      <el-option label="办公椅，旗舰版，500" value="3"></el-option>
                      <el-option label="显示器，旗舰版，1000" value="4"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
            <div class="addButton">
              <!--              <el-button type="primary" @click="onSubmit" :disabled="addDisabled" size="small">添加至清单</el-button>-->
              <el-button plain disabled @click="onSubmit" v-show="addDisabled" size="small">添加至清单</el-button>
              <el-button type="primary"  @click="onSubmit" v-show="!addDisabled" size="small">添加至清单</el-button>
            </div>
          </div>
          <div class="form-box-table">
            <el-table
              :data="tableData"
              border
              style="width: 100%">
              <el-table-column
                label="货物名称"
                align="center"
                width="70">
                <template slot-scope="scope">
                  <!--                  <i class="el-icon-time"></i>-->
                  <span>{{ scope.row.name }}</span>
                </template>
              </el-table-column>
              <el-table-column align="center" width="60" prop="spec" label="规格"></el-table-column>
              <el-table-column align="center" prop="price" label="单价(元)" width="70"></el-table-column>
              <el-table-column align="center" prop="quantity" label="数量(个)" width="70"></el-table-column>
              <el-table-column align="center" prop="total" label="总价(元)" width="70"></el-table-column>
              <!--              <el-table-column prop="tax" label="税额（元）">-->
              <!--                <template slot-scope="scope">-->
              <!--                  &lt;!&ndash;                  <i class="el-icon-time"></i>&ndash;&gt;-->
              <!--                  <span>{{ scope.row.tax }}</span>-->
              <!--                </template>-->
              <!--              </el-table-column>-->

              <!--              <el-table-column-->
              <!--                label="姓名"-->
              <!--                width="180">-->
              <!--                <template slot-scope="scope">-->
              <!--                  <el-popover trigger="hover" placement="top">-->
              <!--                    <p>姓名: {{ scope.row.name }}</p>-->
              <!--                    <p>住址: {{ scope.row.address }}</p>-->
              <!--                    <div slot="reference" class="name-wrapper">-->
              <!--                      <el-tag size="medium">{{ scope.row.name }}</el-tag>-->
              <!--                    </div>-->
              <!--                  </el-popover>-->
              <!--                </template>-->
              <!--              </el-table-column>-->
              <el-table-column label="操作" align="center">
                <template slot-scope="scope">
                  <!--                  <el-button-->
                  <!--                    size="mini"-->
                  <!--                    @click="handleEdit(scope.$index, scope.row)">编辑</el-button>-->
                  <el-button
                    size="mini"
                    type="danger"
                    @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="form-box-select">
            <span style="font-size: 14px;color: #606266;padding-right: 6px">供货时间：</span>
            <el-select v-model="supplyTime" size="small" placeholder="请选择供货时间">
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>
            <el-divider></el-divider>

          </div>
          <div class="box-button">
            <el-button plain size="small" @click="resetData" :disabled="submitNull()">重置内容</el-button>
            <!--            <el-button plain size="small" type="primary" @click="submitData" :disabled="submitNull()">确认填写</el-button>-->
            <el-button size="small" type="primary" @click="submitData" v-show="!submitNull()">确认填写</el-button>
            <el-button size="small" plain @click="submitData" disabled v-show="submitNull()">确认填写</el-button>
          </div>
        </div>
        <div class="form-box" v-show="showOneKeyClear">
          <el-button @click="onOneKeyClear">一键清稿</el-button>
        </div>
      </div>

      <div class="right-editor">
        <new-editor v-bind:config="config"
                    v-on:onGetEditor="propsEditor"
                    v-on:onGetDocContent="propsDocContent"
        ></new-editor>
      </div>
    </div>
  </div>
</template>

<script>
    import axios from 'axios';
    import leftBar from "./leftBar";
    import NewEditor from "./newEditor";
    import OtherApplication from '../components/otherApplication'

    export default {
        name: "openEditor",
        components: {NewEditor, leftBar, OtherApplication},

        data() {
            return {
                baseUrl: config.baseUrl ,
                docEditor: null,
                ctctrlTree: null,
                ctctrlContentAll: null,
                extractedText: null,
                extractedRevision: null,
                outjson: null,
                extractedComment: null,
                extractedCellContent: null,
                extractedCellContentAll: null,
                // 编辑器参数
                config: {
                    type: "",
                    // width: (type == "desktop" ? width : undefined),
                    width: '100%',
                    height: window.innerHeight,
                    documentType: "",
                    token: "",
                    document: {
                        usePdfjs:false,
                        title: "",
                        url: "",
                        fileType: "",
                        key: "",
                        info: {
                            author: "我",
                            created: ""
                        },
                        permissions: {
                            canSetTypeData:true,
                            comment: true,
                            edit: true,
                            review: true,
                            modifyFilter: true,
                            download: true,
                            print: true,
                            copyoutenabled: true,
                            showReview: true,
                            setPermissionShow: true,
                            watermark:true,
                        },
                    },

                  editorConfig: {
                    "plugins": {
                      //"autostart": [                  //文档打开完成后，自动启动插件列表
                      //  "asc.{639E69BC-58DE-4029-9B43-F0420F67E6F0}"
                      //],
                      "pluginsData": [
                        "http://" + window.document.location.hostname+":"+window.document.location.port+"/public/example/config.json"
                      ]
                    },
                        typeDataList:[{'id': '123',
                            //数据项ID，必填
                            'name': 'a',
                            //数据项名称，必填
                            'pos': 'Sheet1!A1:A1',
                            //数据项位置，必填
                            'color': '#7CB7F2'
                            //选填，默认为#00B050
                            }],
                        mode: "edit",
                        callbackUrl: "",
                        user: {
                            "id": "userid",
                            "name": "username",
                        },
                        embedded: {
                            saveUrl: "",
                            embedUrl: "",
                            shareUrl: "",
                            toolbarDocked: "top",
                        },
                        customization: {
                            about: true,
                            chat: false,
                            comments: true,
                            zoom: 100,
                            leftMenu: true,
                            rightMenu: true,
                            toolbar: true,
                            header: true,
                            statusBar: true,
                            autosave: true,
                            forcesave: true,
                            displayTitle: true,
                            goback: "",
                            reviewDisplay: 'markup',
                            isCompareWithUrl:false,
                            compareWithUrl:"",
                            disabledAddTypeData:true,
                            watermark: {
                                transparent: 0.3, //透明度     默认为0.3,范围是0-1
                                type: "rect",//水印类型  rect为矩形  ellipse为椭圆
                                width: 0,//水印宽度，单位为mm
                                height: 0,//水印宽度，单位为mm
                                rotate: 0,//水印旋转角度   360为旋转一周，正数为向右侧旋转，负数向左侧旋转
                                margins: [10,5,5,10],//段落距边框的留白区域[l,t,r,b]
                                fill: [],//水印填充颜色[] => none
                                "stroke-width" : '',//描边宽度单位为mm
                                stroke: [],//描边的颜色[] => none
                                align: 0,// 垂直方向文本对齐方式(4 - 顶端对齐, 1 - 居中对齐, 0 -底端对齐)
                                paragraphs: [//目前只支持第一个元素的显示，更多元素会被忽略
                                {
                                align: 0,//水平方向文本对齐方式 [1 -左对齐, 2 - 居中对齐, 0 -右对齐]
                                fill: [],//段落背景色
                                linespacing: 1.0,  //行间距（倍数）
                                runs: [//目前写在前面的元素会后显示，写在后面的会先显示，也就是说显示结果和书写顺序成倒序
                                {
                                    text: "",//文字内容，其中%user_name%会被替换为当前用户的名字
                                    fill: [],//文字颜色
                                    "font-family" : "simsun",//文字使用的字体属性
                                    "font-size": 72,//文字字号
                                    bold: true,//粗体
                                    italic: false,//斜体
                                    strikeout: false,//删除线
                                    underline: false,//下划线
                                },
                                {
                                    text: ""//新起一行，需单独书写，不可和其它文本内容写到一起
                                },
                                {
                                    text: ""
                                }
                                ]}
                            ]}
                        },
                        limitEditMode: 'nolimit',
                        lang: 'zh',

                    },
                },
                showLeftBar: true,
                fileType: 'pptx',


              form: {
                aName: '',
                bName: '',
                projectNumber: '',
                shop: ''
              },
              //商品数据
              shopData: [
                {
                  "id":1,
                  "name": "计算机",
                  "spec": "标准版",
                  "model": "550A",
                  "unit": "台",
                  "quantity": 5,
                  "price": 10000,
                  "total": 50000,
                  "tax": 56500
                },
                {
                  "id":2,
                  "name": "办公桌",
                  "spec": "高级版",
                  "model": "550A",
                  "unit": "台",
                  "quantity": 5,
                  "price": 1000,
                  "total": 5000,
                  "tax": 5650
                },
                {
                  "id":3,
                  "name": "办公椅",
                  "spec": "旗舰版",
                  "model": "550A",
                  "unit": "台",
                  "quantity": 5,
                  "price": 500,
                  "total": 2500,
                  "tax": 2825
                },
                {
                  "id":4,
                  "name": "显示器",
                  "spec": "旗舰版",
                  "model": "550A",
                  "unit": "台",
                  "quantity": 5,
                  "price": 1000,
                  "total": 5000,
                  "tax": 5650
                }
              ],
              addDisabled: true,//添加按钮状态
              tableData: [],
              //供货下拉框
              options: [{
                value: '7',
                label: '7天'
              }, {
                value: '15',
                label: '15天'
              }, {
                value: '30',
                label: '30天'
              }],
              supplyTime: null,//供货时间
              ctctrlData: null,
              once: true,


              showQuickBar:false,
              showContract: true,//显示合同信息
              showOneKeyClear:false,//一键清稿
              // submitNull: true,//重置内容和确认提交按钮默认disabled
            };
        },
        created() {
          this.showLeftBar = (undefined === this.$route.query.showLeftBar ||this.$route.query.showLeftBar == 'true') ? true : false
          this.showQuickBar = this.$route.query.showQuickBar;
          this.showContract = this.$route.query.showContract;
          // this.showOneKeyClear = this.$route.query.showOneKeyClear;
          console.log(this.$route.query)

            // this.config["events"] = this.events;
            this.fileType = this.$route.query.fileType ? this.$route.query.fileType : this.$route.query.fileExt
            // log("type in openeditor:", this.fileType)
            var fileName = this.$route.query.fileName
            var userid = this.$route.query.userid
            var name = this.$route.query.name
            var mode = this.$route.query.mode            // mode: view/edit/review/comment/embedded
            var lang = this.$route.query.lang || 'zh'
            var type = this.$route.query.type            // type: embedded/mobile/desktop
            var fileExt = this.$route.query.fileExt      // 新建文档扩展名
            var sample = this.$route.query.sample        // 新建文档时用模板
            var leftMenu = this.$route.query.leftMenu || 'true'
            var rightMenu = this.$route.query.rightMenu || 'true'
            var isCompareWithUrl = this.$route.query.isCompareWithUrl || 'false'
            var compareWithUrl = this.$route.query.compareWithUrl || 'false'
            var statusBar = this.$route.query.statusBar || 'true'
            var header = this.$route.query.header || 'true'
            var toolbar = this.$route.query.toolbar || 'true'
            // var download = this.$route.query.download || 'true'
            // var print = this.$route.query.print || 'true'
          var download = false
          var print = false
            var copyoutenabled = this.$route.query.copyoutenabled || 'true'
            var mode = this.$route.query.mode;
            var width = this.$route.query.waterWidth
            var transparent = this.$route.query.transparent;
            var types = this.$route.query.types;
            var height = this.$route.query.waterHeight;
            var rotate = this.$route.query.rotate;
            var margins = this.$route.query.margins;
            var waterfill = this.$route.query.waterfill
            var strokeWidth = this.$route.query.strokeWidth;
            var stroke = this.$route.query.stroke;
            var align = this.$route.query.align;
            var Walign = this.$route.query.Walign;
            var Wfill = this.$route.query.waterWfill
            var linespacing = this.$route.query.linespacing;
            var fontFamily = this.$route.query.fontFamily;
            var text = this.$route.query.text;
            var fontSize = this.$route.query.fontSize;
            var fontColor = this.$route.query.fontColor;
            var bold = this.$route.query.bold;
            var italic = this.$route.query.italic;
            var strikeout = this.$route.query.strikeout
            var underline = this.$route.query.underline;
            var shape = this.$route.query.shape;
            var font = this.$route.query.font;
            var Wfont = this.$route.query.Wfont;
            this.config.type = (mode === 'mobile' || mode === 'previewMobile') ? 'mobile' : (mode === 'embedded' ? 'embedded' : 'desktop');
            this.config.document.permissions.comment = mode !== 'review';
            this.config.document.permissions.review = mode !== 'comment';
            this.config.document.permissions.edit = mode !== 'review' && mode !== 'comment'; // 修订,批注,只读 为 false
            this.config.document.permissions.modifyFilter = mode !== 'filter';
            // this.config.document.permissions.download = this.$route.query.download ? JSON.parse(this.$route.query.download) : true;
            // this.config.document.permissions.print = this.$route.query.print ? JSON.parse(this.$route.query.print) : true;
          this.config.document.permissions.download = false;//关闭下载
          this.config.document.permissions.print = false;//关闭打印
            this.config.document.permissions.copyoutenabled = this.$route.query.copyoutenabled ? JSON.parse(this.$route.query.copyoutenabled) : true;

            this.config.editorConfig.user.id = this.$route.query.userid;
            this.config.editorConfig.user.name = this.$route.query.name;
            this.config.editorConfig.mode = (mode !== 'preview' && mode !=='embeded' && mode !== 'previewMobile') ? 'edit' : 'view';
            this.config.editorConfig.limitEditMode = (mode === 'content') ? 'ctctrl' : 'nolimit';
            this.config.editorConfig.customization.leftMenu = this.$route.query.leftMenu ? JSON.parse(this.$route.query.leftMenu) : true;
            this.config.editorConfig.customization.rightMenu = this.$route.query.rightMenu ? JSON.parse(this.$route.query.rightMenu) : true;
            this.config.editorConfig.customization.statusBar = this.$route.query.statusBar ? JSON.parse(this.$route.query.statusBar) : true;
            // this.config.editorConfig.customization.header = JSON.parse(this.$route.query.header);
            this.config.editorConfig.customization.toolbar = this.$route.query.toolbar ? JSON.parse(this.$route.query.toolbar) : true;
            this.config.editorConfig.customization.isCompareWithUrl = this.$route.query.isCompareWithUrl ? JSON.parse(this.$route.query.isCompareWithUrl) : false;
            this.config.editorConfig.customization.compareWithUrl = this.$route.query.compareWithUrl;
            this.config.editorConfig.customization.reviewDisplay = this.$route.query.reviewDisplay || 'markup'
            // this.config.editorConfig.customization.reviewDisplay = localStorage.getItem('viewMode') || 'markup';
            this.config.editorConfig.lang = this.$route.query.lang || 'zh';
            this.config.editorConfig.customization.watermark.margins=this.$route.query.margins ? this.$route.query.margins.map(Number):[]
            console.log("this.$route.query.margins",this.$route.query.margins)
            // console.log("mappppppp",this.$route.query.margins.map(Number))
            this.config.editorConfig.customization.watermark.fill=this.$route.query.waterfill
            this.config.editorConfig.customization.watermark['stroke-width']=Number(this.$route.query.strokeWidth)
            this.config.editorConfig.customization.watermark.stroke=this.$route.query.stroke
            this.config.editorConfig.customization.watermark.align=Number(this.$route.query.fond)
            this.config.editorConfig.customization.watermark.type=this.$route.query.shape
            this.config.editorConfig.customization.watermark.paragraphs[0].align=Number(this.$route.query.Wfond)
            this.config.editorConfig.customization.watermark.paragraphs[0].fill=this.$route.query.Wfill
            this.config.editorConfig.customization.watermark.paragraphs[0].linespacing= Number(this.$route.query.linespacing)
            this.config.editorConfig.customization.watermark.paragraphs[0].runs[0]['font-family']=this.$route.query.fontFamily||"simsun"
            this.config.editorConfig.customization.watermark.paragraphs[0].runs[0]['font-size']=Number(this.$route.query.fontSize)||12
            this.config.editorConfig.customization.watermark.paragraphs[0].runs[0].fill=this.$route.query.fontColor||[]
            this.config.editorConfig.customization.watermark.paragraphs[0].runs[0].bold=this.$route.query.bold=="false" ? false : true
            this.config.editorConfig.customization.watermark.paragraphs[0].runs[0].italic=this.$route.query.italic=="false" ? false : true
            this.config.editorConfig.customization.watermark.paragraphs[0].runs[0].strikeout=this.$route.query.strikeout=="false" ? false : true
            this.config.editorConfig.customization.watermark.paragraphs[0].runs[0].underline=this.$route.query.underline=="false" ? false : true
            console.log("runnnnnn",this.config.editorConfig.customization.watermark.paragraphs[0].runs[0])
            this.config.editorConfig.customization.watermark.transparent=Number(this.$route.query.transparent)||0.3;
            this.config.editorConfig.customization.watermark.width=Number(this.$route.query.waterWidth)||0;
            this.config.editorConfig.customization.watermark.height=Number(this.$route.query.waterHeight)||0;
            this.config.editorConfig.customization.watermark.rotate=Number(this.$route.query.rotate)||0;
            this.config.editorConfig.customization.watermark.paragraphs[0].runs[0].text=this.$route.query.text||'';
          console.log('this.$route.query.waterWidth',this.$route.query.waterWidth)
          this.config.editorConfig.token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.MTIyMw.dtrnzOJ2NDa3F9noWiddoAjtHSfhdMVDloQU93UfJUE";
            var data = {
                fileExt: fileExt,
                sample: sample,
                mode: mode,
                fileName: fileName,
                userid: userid,
                name: name,
                lang: lang,
                type: type,
                leftMenu: leftMenu,
                rightMenu: rightMenu,
                isCompareWithUrl:isCompareWithUrl,
                compareWithUrl:compareWithUrl,
                statusBar: statusBar,
                header: header,
                toolbar: toolbar,
                download: download,
                print: print,
                copyoutenabled: copyoutenabled,
                transparent:transparent,
                types:types,
                // watermark:watermark,
                width:width,
                height:height,
                rotate:rotate,
                margins:margins,
                waterfill:waterfill,
                strokeWidth:strokeWidth,
                stroke:stroke,
                align:align,
                Walign:Walign,
                Wfill:Wfill,
                linespacing:linespacing,
                text:text,
                fontColor:fontColor,
                fontFamily:fontFamily,
                fontSize:fontSize,
                bold:bold,
                italic:italic,
                strikeout:strikeout,
                underline:underline,
                Wfont:Wfont,
                font:font,
                shape:shape,
              key:this.$route.query.key,//打开编辑器的key
              docUrl: this.$route.query.docUrl
            }
            // log("提交的data", data)
            // 获取 editor config 参数
            console.log(this.baseUrl,'baseurlurlurlurl')
            axios.post(this.baseUrl + '/editor', data).then(r => {
                var d = r.data;
                this.cleanData(d);
                console,log(window.document.location,'window.document.location')
            })
        },
        updated() {
        },
        mounted() {
          this.changeAdd();
          this.once = true;
          // this.submitNull();
        },
      watch: {
        ctctrlData: {
          handler(newVal) {
            if (this.once && !(newVal && newVal.length > 0)) {
              this.resetData();
              this.once = false
            }
          },
          immediate: true,
        },
      },
        methods: {
          oneKeyComment() {
            console.log(1111111112222);
            var that = this
            if (that.docEditor) {
              var expression = {
                object: 'comment',//"atfield":正文@；“comment”：批注@
                type: 'add',
                list: [{
                  id: 'uid-2',
                  name: 'Mark Pottato',
                }],
                checkSymbol: false
              };
              that.docEditor.setDocumentContent(expression)
            } else {
              console.log('docEditor is null');
            }
          },

          onSubmit() {
            let that = this;
            this.shopData.filter((item) => {
              if (item.id == that.form.shop) {
                that.tableData.push(item)
              }
            })
            this.addDisabled = this.tableData.length >= 5;//限制添加5个数据
          },
          changeAdd() {
            //限制添加0-5个数据
            // this.form.shop == ''?this.addDisabled=true:this.addDisabled=false;
            this.addDisabled = this.form.shop == '' || this.tableData.length >= 5;
          },
          handleEdit(index, row) {
            console.log(index, row);
          },
          handleDelete(index, row) {
            console.log(index, row);
            this.tableData.splice(index, 1)//修改删除相同id
            // this.tableData = this.tableData.filter((item) => {
            //   return item.id != row.id
            // })
            this.addDisabled = this.form.shop == '' || this.tableData.length >= 5;//删除时可以点击添加
          },
          //有一项不为空放开提交按钮
          submitNull() {
            return this.form.aName == ''&&this.form.bName==''&&this.form.shop==''&&this.form.projectNumber==''&&this.supplyTime==null;
          },
          resetData() {
            this.form.aName = '';
            this.form.bName = '';
            this.form.projectNumber = '';
            this.form.shop = '';
            this.tableData = [];
            this.supplyTime = null;

            this.submitNull();//重置按钮
            this.addDisabled = true;//重置按钮

            let expression, that = this;
            let tableStr = `{"body":[{"table":[{"@cellpadding":0},{"tbody":[{"tr":[{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:86.8pt;"},{"p":[{"span":[{"@value":"货物名称 ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:102.85000000000002pt;"},{"p":[{"span":[{"@value":"规格 ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:70.85000000000001pt;"},{"p":[{"span":[{"@value":"单价（元） ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:75.90000000000002pt;"},{"p":[{"span":[{"@value":"数量（个） ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:105.64999999999998pt;"},{"p":[{"span":[{"@value":"总价（元） ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"@style":"height:15.05pt;"}]},{"tr":[{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:86.8pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:102.85000000000002pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:70.85000000000001pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:75.90000000000002pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:105.64999999999998pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"@style":"height:13.8pt;"}]},{"tr":[{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:86.8pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:102.85000000000002pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:70.85000000000001pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:75.90000000000002pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:105.64999999999998pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"@style":"height:13.8pt;"}]},{"tr":[{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:86.8pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:102.85000000000002pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:70.85000000000001pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:75.90000000000002pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"td":[{"@style":"border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:105.64999999999998pt;"},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"}]}]},{"@style":"height:13.8pt;"}]},{"@style":"margin-left:0pt;mso-padding-alt:0pt 5.4pt 0pt 5.4pt;mso-border-insideh:0.5pt solid #000000;mso-border-insidev:0.5pt solid #000000;"}]}]},{"p":[{"span":[{"@value":" ","@style":"font-family:Arial;color:#000000;font-size:12pt;"}]},{"@style":"text-align:left;margin-top:0pt;margin-bottom:10pt;line-height:114%;"}]}]}`
            if (this.ctctrlData) {
              let contentData = [...this.ctctrlData.contentcontrols];
              contentData.filter((item) => {
                if (item['Alias'] == '甲方名称') {
                  // 在文字处理中设置内容域的文字内容，内容域的内容会全部被清除，会按照第一个文字的格式进行格式设置
                  expression = {
                    object: "content",      // 表示操作对象为内容域，必填项
                    type: "clear",          //表示是清除内容域内容，必填项
                    name: "",               // 内容域的标签，可以是英文数字，优先级高于ID
                    id: item['id'],                // 内容域的ID，name和id必须有一
                    // value: '甲方名称'         // 替换完成后内容域内的文字内容
                  };
                  that.docEditor.setDocumentContent(expression)
                }
                else if (item['Alias'] == '乙方名称') {
                  // 清除指定内容域内容（仅限富文本内容域）
                  expression = {
                    object: "content",  //表示是文档控制域，必填项
                    type: "clear",      //表示是清除内容域内容，必填项
                    name: '',          //内容域的标签
                    id: item['id'],            //内容域的id
                  }
                  that.docEditor.setDocumentContent(expression)
                }
                else if (item['Alias'] == '项目编号') {
                  // 清除指定内容域内容（仅限富文本内容域）
                  expression = {
                    object: "content",  //表示是文档控制域，必填项
                    type: "clear",      //表示是清除内容域内容，必填项
                    name: '',          //内容域的标签
                    id: item['id'],            //内容域的id
                  }
                  that.docEditor.setDocumentContent(expression)
                }
                else if (item['Alias'] == '合同货物信息') {
                  // 除了纯文本其余都填json串，html格式
                  expression = {
                    object: "content",      //表示是文档控制域，必填项
                    type: "html",           //表示添加内容为html
                    name: '',               //内容域的标签
                    id: item['id'],                //内容域的id
                    jsonStr: tableStr,            //必填项,添加到内容域的json对象或字符串,格式模拟html，详见样例
                    bClear: true,          //是否清空指定内容域的内容，默认为false不清除.
                  };
                  if (tableStr) {
                    that.docEditor.setDocumentContent(expression)
                  } else {
                    // that.$message({
                    //   showClose: true,
                    //   message: '请输入表格信息',
                    //   type: 'warning'
                    // });
                  }
                }
                else if (item['Alias'] == '供货时间') {
                  // 清除指定内容域内容（仅限富文本内容域）
                  expression = {
                    object: "content",  //表示是文档控制域，必填项
                    type: "clear",      //表示是清除内容域内容，必填项
                    name: '',          //内容域的标签
                    id: item['id'],            //内容域的id
                  }
                  that.docEditor.setDocumentContent(expression)
                }
                else {
                  console.log('please input text')
                }
              })

            } else {
              console.log(this.ctctrlData,'ctctrlData is null!')
            }
          },
          submitData() {
            let expression,that = this;
            let tableStr = '';
            for (let tableItem of this.tableData) {
              tableStr += `{
                            "tr": [
                                {
                                    "td": [
                                        {
                                            "@style": "border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:86.8pt;"
                                        },
                                        {
                                            "p": [
                                                {
                                                    "span": [
                                                        {
                                                            "@value": "${tableItem.name}",
                                                            "@style": "font-family:Arial;color:#000000;font-size:12pt;"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "@style": "text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "td": [
                                        {
                                            "@style": "border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:102.85000000000002pt;"
                                        },
                                        {
                                            "p": [
                                                {
                                                    "span": [
                                                        {
                                                            "@value": "${tableItem.spec}",
                                                            "@style": "font-family:Arial;color:#000000;font-size:12pt;"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "@style": "text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "td": [
                                        {
                                            "@style": "border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:70.85000000000001pt;"
                                        },
                                        {
                                            "p": [
                                                {
                                                    "span": [
                                                        {
                                                            "@value": "${tableItem.price}",
                                                            "@style": "font-family:Arial;color:#000000;font-size:12pt;"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "@style": "text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "td": [
                                        {
                                            "@style": "border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:75.90000000000002pt;"
                                        },
                                        {
                                            "p": [
                                                {
                                                    "span": [
                                                        {
                                                            "@value": "${tableItem.quantity}",
                                                            "@style": "font-family:Arial;color:#000000;font-size:12pt;"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "@style": "text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "td": [
                                        {
                                            "@style": "border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:105.64999999999998pt;"
                                        },
                                        {
                                            "p": [
                                                {
                                                    "span": [
                                                        {
                                                            "@value": "${tableItem.total}",
                                                            "@style": "font-family:Arial;color:#000000;font-size:12pt;"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "@style": "text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "@style": "height:13.8pt;"
                                }
                            ]
                        },`
            }
            tableStr = `{
    "body": [
        {
            "table": [
                {
                    "@cellpadding": 0
                },
                {
                    "tbody": [
                        {
                            "tr": [
                                {
                                    "td": [
                                        {
                                            "@style": "border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:86.8pt;"
                                        },
                                        {
                                            "p": [
                                                {
                                                    "span": [
                                                        {
                                                            "@value": "货物名称 ",
                                                            "@style": "font-family:Arial;color:#000000;font-size:12pt;"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "@style": "text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "td": [
                                        {
                                            "@style": "border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:102.85000000000002pt;"
                                        },
                                        {
                                            "p": [
                                                {
                                                    "span": [
                                                        {
                                                            "@value": "规格 ",
                                                            "@style": "font-family:Arial;color:#000000;font-size:12pt;"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "@style": "text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "td": [
                                        {
                                            "@style": "border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:70.85000000000001pt;"
                                        },
                                        {
                                            "p": [
                                                {
                                                    "span": [
                                                        {
                                                            "@value": "单价（元） ",
                                                            "@style": "font-family:Arial;color:#000000;font-size:12pt;"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "@style": "text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "td": [
                                        {
                                            "@style": "border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:75.90000000000002pt;"
                                        },
                                        {
                                            "p": [
                                                {
                                                    "span": [
                                                        {
                                                            "@value": "数量（个） ",
                                                            "@style": "font-family:Arial;color:#000000;font-size:12pt;"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "@style": "text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "td": [
                                        {
                                            "@style": "border-left:0.5pt solid #000000;border-top:0.5pt solid #000000;border-right:0.5pt solid #000000;border-Bottom:0.5pt solid #000000;width:105.64999999999998pt;"
                                        },
                                        {
                                            "p": [
                                                {
                                                    "span": [
                                                        {
                                                            "@value": "总价（元） ",
                                                            "@style": "font-family:Arial;color:#000000;font-size:12pt;"
                                                        }
                                                    ]
                                                },
                                                {
                                                    "@style": "text-align:left;margin-top:0pt;margin-bottom:0pt;line-height:normal;"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "@style": "height:15.05pt;"
                                }
                            ]
                        },
                        ${tableStr}
                        {
                            "@style": "margin-left:0pt;mso-padding-alt:0pt 5.4pt 0pt 5.4pt;mso-border-insideh:0.5pt solid #000000;mso-border-insidev:0.5pt solid #000000;"
                        }
                    ]
                }
            ]
        },
        {
            "p": [
                {
                    "span": [
                        {
                            "@value": " ",
                            "@style": "font-family:Arial;color:#000000;font-size:12pt;"
                        }
                    ]
                },
                {
                    "@style": "text-align:left;margin-top:0pt;margin-bottom:10pt;line-height:114%;"
                }
            ]
        }
    ]
}`
            if (this.ctctrlData) {
              let contentData = [...this.ctctrlData.contentcontrols];
              contentData.filter((item) => {
                if (item['Alias'] == '甲方名称') {
                  // 在文字处理中设置内容域的文字内容，内容域的内容会全部被清除，会按照第一个文字的格式进行格式设置
                  expression = {
                    object: "content",      // 表示操作对象为内容域，必填项
                    type: "replace",        // 表示操作行为是替换内容，必填项
                    name: "",               // 内容域的标签，可以是英文数字，优先级高于ID
                    id: item['id'],                // 内容域的ID，name和id必须有一
                    value: that.form.aName         // 替换完成后内容域内的文字内容
                  };
                  if (that.form.aName) {
                    that.docEditor.setDocumentContent(expression)
                  } else {
                    // that.$message({
                    //   showClose: true,
                    //   message: '请输入甲方名称',
                    //   type: 'warning'
                    // });
                  }
                }
                else if (item['Alias'] == '乙方名称') {
                  // 在文字处理中设置内容域的文字内容，内容域的内容会全部被清除，会按照第一个文字的格式进行格式设置
                  expression = {
                    object: "content",      // 表示操作对象为内容域，必填项
                    type: "replace",        // 表示操作行为是替换内容，必填项
                    name: "",               // 内容域的标签，可以是英文数字，优先级高于ID
                    id: item['id'],                // 内容域的ID，name和id必须有一
                    value: that.form.bName         // 替换完成后内容域内的文字内容
                  };
                  if (that.form.bName) {
                    that.docEditor.setDocumentContent(expression)
                  } else {
                    // that.$message({
                    //   showClose: true,
                    //   message: '请输入乙方名称',
                    //   type: 'warning'
                    // });
                  }
                }
                else if (item['Alias'] == '项目编号') {
                  // 在文字处理中设置内容域的文字内容，内容域的内容会全部被清除，会按照第一个文字的格式进行格式设置
                  expression = {
                    object: "content",      // 表示操作对象为内容域，必填项
                    type: "replace",        // 表示操作行为是替换内容，必填项
                    name: "",               // 内容域的标签，可以是英文数字，优先级高于ID
                    id: item['id'],                // 内容域的ID，name和id必须有一
                    value: that.form.projectNumber         // 替换完成后内容域内的文字内容
                  };
                  if (that.form.projectNumber) {
                    that.docEditor.setDocumentContent(expression)
                  } else {
                    // that.$message({
                    //   showClose: true,
                    //   message: '请输入项目编号',
                    //   type: 'warning'
                    // });
                  }
                }
                else if (item['Alias'] == '合同货物信息') {
                  // 除了纯文本其余都填json串，html格式
                  expression = {
                    object: "content",      //表示是文档控制域，必填项
                    type: "html",           //表示添加内容为html
                    name: '',               //内容域的标签
                    id: item['id'],                //内容域的id
                    jsonStr: tableStr,            //必填项,添加到内容域的json对象或字符串,格式模拟html，详见样例
                    bClear: true,          //是否清空指定内容域的内容，默认为false不清除.
                  };
                  if (that.tableData.length>0) {
                    that.docEditor.setDocumentContent(expression)
                  } else {
                    // that.$message({
                    //   showClose: true,
                    //   message: '请输入表格信息',
                    //   type: 'warning'
                    // });
                  }
                }
                else if (item['Alias'] == '供货时间') {
                  // 在文字处理中设置内容域的文字内容，内容域的内容会全部被清除，会按照第一个文字的格式进行格式设置
                  expression = {
                    object: "content",      // 表示操作对象为内容域，必填项
                    type: "replace",        // 表示操作行为是替换内容，必填项
                    name: "",               // 内容域的标签，可以是英文数字，优先级高于ID
                    id: item['id'],                // 内容域的ID，name和id必须有一
                    value: that.supplyTime         // 替换完成后内容域内的文字内容
                  };
                  if (that.supplyTime) {
                    that.docEditor.setDocumentContent(expression)
                  } else {
                    // that.$message({
                    //   showClose: true,
                    //   message: '请输入供货时间',
                    //   type: 'warning'
                    // });
                  }
                }
                else {
                  console.log('please input text')
                }
              })

            } else {
              console.log(this.ctctrlData,'ctctrlData is null!')
            }
          },

          onOneKeyClear() {
            // this.docEditor.getDocumentContent
            // ({
            //   object : 'text', //操作文本内容，必填项，固定值
            //   type : 'getComment', //表示获取文档批注，必填项，固定值
            //   tree : false, //   参数说明：批注信息是否按照层级结构显示，参数为boolean类型，   默认为false 选填项。true表示批注信息按照层级结构展示，false表示批注信息  不按照层级结构展示。
            //   user : ['user1','user2'] // 参数说明：根据指定的用户名字获取批注，参数为array，  数组元素为用户的名字 选填项，如传数组为空，则为全部用户
            // })
            this.docEditor.getDocumentContent
            ({
              object:"revision",//操作修订，必填固定项
              type:"addAndDelete",//提取类型为addAndDelete，必填固定项
              range:[]
            })
            console.log('docEditor',this.docEditor);
            // this.docEditor.setDocumentContent({
            //   object : 'comment',
            //   type : 'cleanAll', //表示获取文档批注，必填项，固定值
            // })
            // this.docEditor.setDocumentContent({
            //   object : 'revision',
            //   type : 'cleanAll', //表示获取文档批注，必填项，固定值
            // })
          },
          onClear() {

          },

            cleanData: function(data) {
                // modify on 2020-11-3 填充编辑器参数
                // this.config.type = data.editor.type;
                this.config.documentType = data.editor.documentType;
                this.config.token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.MTIyMw.dtrnzOJ2NDa3F9noWiddoAjtHSfhdMVDloQU93UfJUE"//data.editor.token;
                this.config.document.title = data.file.name;
                this.config.document.url = data.file.uri;
                this.config.document.fileType = data.file.ext;
                this.config.document.key = data.editor.key;
                this.config.document.info.created = data.file.created;
                // this.config.editorConfig.customization.watermark.width=JSON.parse(config.data).watermark.width;
                // this.config.document.permissions.comment = data.editor.comment;
                // this.config.document.permissions.review = data.editor.review;
                // this.config.document.permissions.edit = data.editor.edit;       // 修订,批注,只读 为 false
                // this.config.document.permissions.modifyFilter = data.editor.modifyFilter;
                // this.config.document.permissions.download = data.editor.download;
                // this.config.document.permissions.print = data.editor.print;
                // this.config.document.permissions.copyoutenabled = data.editor.copyoutenabled;
                // this.config.editorConfig.mode = data.editor.mode;               // 只读模式（view）| 编辑模式（edit）
                this.config.editorConfig.callbackUrl = data.editor.callbackUrl + "/&userid=" + data.editor.userid+"/&username=" + data.editor.name;
              // this.config.editorConfig.callbackUrl = "../../static/muban.docx" + "/&userid=" + data.editor.userid+"/&username=" + data.editor.name;
                // this.config.editorConfig.user.id = data.editor.userid;
                // this.config.editorConfig.user.name = data.editor.name;
                this.config.editorConfig.embedded.saveUrl = data.file.uri;
                this.config.editorConfig.embedded.embedUrl = data.file.uri;
                this.config.editorConfig.embedded.shareUrl = data.file.uri;
            },
          getTitle(url) {

                let name = url.substr(url.lastIndexOf("/") + 1);
                return name;
            },
            getGUID() {
                return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, function(
                    c
                ) {
                    var r = (Math.random() * 16) | 0,
                        v = c === "x" ? r : (r & 0x3) | 0x8;
                    return v.toString(16);
                });
            },
          propsEditor: function (e) {
                this.docEditor = e;
            },
            propsDocContent: function (data) {
                console.log("datattttttt",data)
              this.ctctrlData = data;
                // this.resetData();
                var object = data.object;
                var type = data.type;
                if (object === 'content') {
                    if (type === 'contentControlChildren') {
                        this.ctctrlTree = data;
                    } else if (type === 'all' || type === 'text') {
                        this.ctctrlContentAll = data;
                    }else if (type === 'json'){
                        this.outjson = data
                    }
                } else if (object === 'text') {
                    if (type === 'selected') {
                        this.extractedText = data;
                    } else if (type === 'getComment') {
                        this.extractedComment = data;
                    }
                }else if (object === 'revision') {
                    if (type === 'addAndDelete') {
                        this.extractedRevision = data;
                    }
                }else if (object == "comment") {
                    this.extractedComment = data;
                }
                // 表格
                if (type === 'cellrange') {
                    this.extractedCellContent = data;
                } else if (type === 'cellrangeall') {
                    this.extractedCellContentAll = data;
                }
            },
            actionShowLeftBar: function (e) {
                this.showLeftBar = !this.showLeftBar;
                var text = e.target.innerHTML;
                var target = this.$refs.show
                if (text === '收起') {
                    target.style.left = '0'
                } else if (text === '展开') {
                    target.style.left = '276px'
                }
            }
        }
    }

</script>

<style scoped>
.readOnly {
  background-color: #f8d7da;
  color: #721c24;
  padding: 10px;
  text-align: center;
/*float: left;
 margin-bottom: 80px;*/
  font-size: 16px;
}
    #id-left-button {
        position: absolute;
        width: 25px;
        height: 40px;
        padding: 0;
        border: 0;
        /* bottom: 112px; */
        top: 600px;
        /*left: 276px;*/
        left: 0;
        background-color: #dbdce8;
        overflow: visible;
        z-index: 1001;
        /* border-top-right-radius: calc(38px); */
        /* border-bottom-right-radius: calc(38px); */
        opacity: 0.5;
        transition: width 0.5s;
        -webkit-transition: width 0.5s;
        cursor: pointer;
    }
    .container {
        display: flex;
        /*height: 937px;*/
      height: 100vh;
      overflow: hidden;
    }
    .right-editor {
        width: 100%;
    }
    .left-bar {
        background: #F6F6F6;
        border: 1px solid #DBDBDB;
        width: 300px;
        min-width: 300px;
        /*margin: 2px;*/
    }

    .addButton {
      padding-bottom: 24px;
      display: flex;
      justify-content: flex-end;
    }
    .quick-bar {
      width: 700px;
      overflow-y: auto;
      height: 100vh;
    }
    .form-box {
      margin: 24px;
    }
    .form-box-title {
      margin: 10px 0 20px 0;
      font-size: 24px;
      font-weight: 700;
      font-style: normal;
    }
    .form-box-select {
      margin-top: 20px;
    }
    .box-button {
      display: flex;
      justify-content: space-evenly;
    }

</style>



// WEBPACK FOOTER //
// src/views/openEditor.vue